import { EstructuraBase } from './estructura-base';

export class FormTextbox extends EstructuraBase<string> {
    controlType = 'textbox';
    //type: string;
    /*maxlength:number;
    minlength:number;
    email: number;
    number:number;*/

    constructor(options: {} = {}) {
        super(options);
        //this.type = options['type'] || '';
        /*this.maxlength = options['maxlength'] === undefined ? 1 : options['maxlength'];
        this.minlength = options['minlength'] === undefined ? 1 : options['minlength'];
        this.email = options['email'] === undefined ? 1 : options['email'];
        this.number = options['number'] === undefined ? 1 : options['number'];*/
    }
}
